import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import * as S from './styles';

type OwnProps = {
  id: number;
  name: string;
  logo: string | null;
  pathName: string;
};

const RecommendedRetailer = memo(({ name, logo, pathName, id }: OwnProps) => {
  const { linkTo, t } = useContext(AppContext);

  const renderTextWithIcon = () => (
    <S.Link to={linkTo('brand', { pathName, id })}>
      <S.Text>
        {t('store', 'store.recommended-retailer-brand', { brand: name })}
      </S.Text>
    </S.Link>
  );

  return (
    <S.RecommendedRetailerExpansion>
      {renderTextWithIcon()}

      {logo ? (
        <S.LogoWrapper to={linkTo('brand', { pathName, id })}>
          <S.Logo src={logo} alt={name} />
        </S.LogoWrapper>
      ) : null}
    </S.RecommendedRetailerExpansion>
  );
});

export default RecommendedRetailer;
